module.exports = __webpack_public_path__ + "static/media/CarAdvise_Business Logo.89ad4691.svg";